<template>
    <div>
        <b-modal id="total-log-modal" ref="totalLogModal" hide-footer @hidden="beforeHide" body-class="total-log-body">
            <template #modal-header>
                <div class="header-container">
                    <div style="display: flex; align-items: center; width: 40%">
                        <span class="header-title">{{ "수집 데이터 관리" }}</span>
                        <span class="badge ptAddr">{{ pointInfo.ptAddr ?? "-" }}</span>
                        <span class="badge ptIdx">{{ pointInfo.ptIdx ?? "-" }}</span>
                        <span class="badge option">{{ pointInfo.equipName ?? "-" }}</span>
                        <span class="badge option">{{ unit ?? "-" }}</span>
                        <span class="badge option">{{ pointDetailInfo.applyZoneIdx ?? "-" }}</span>
                        <span class="badge option">{{ pointDetailInfo.itemUseageCode ?? "-" }}</span>
                        <span class="badge option">{{ pointDetailInfo.energySourceCode ?? "-" }}</span>
                    </div>
                    <div style="display: flex; align-items: center; width: 40%; justify-content: flex-end">
                        <div class="date-picker-container">
                            <div class="btn-group fixedheight">
                                <button
                                    class="btn quickDateButton btn-sm"
                                    @click="quickSelect('before30day', -30)"
                                    style="border: 1px solid #ced4da"
                                >
                                    {{ "-30 D" }}
                                </button>
                                <button
                                    class="btn quickDateButton btn-sm"
                                    @click="quickSelect('before7day', -7)"
                                    style="border-top: 1px solid #ced4da; border-bottom: 1px solid #ced4da"
                                >
                                    {{ "-7 D" }}
                                </button>
                                <button
                                    class="btn quickDateButton btn-sm notBorderRadius"
                                    @click="moveDate(-1)"
                                    style="border: 1px solid #ced4da"
                                >
                                    {{ "-1 D" }}
                                </button>
                            </div>
                            <div style="width: 200px">
                                <DatePicker
                                    ref="datePicker"
                                    v-model="day"
                                    :type="'day'"
                                    :format="'YYYY년 MM월 DD일 dddd'"
                                    :valueType="'YYYYMMDD'"
                                    :placeholder="'일자 선택'"
                                    lang="ko"
                                    :append-to-body="false"
                                    @change="onDayChange(day)"
                                    class="fixedheight"
                                    :disabled-date="disableFutureDates"
                                />
                            </div>
                            <div class="btn-group fixedheight">
                                <button
                                    class="btn quickDateButton btn-sm notBorderRadius"
                                    @click="moveDate(1)"
                                    :disabled="isFutureDisabled"
                                    style="border: 1px solid #ced4da"
                                >
                                    {{ "+1 D" }}
                                </button>
                                <button
                                    class="btn quickDateButton btn-sm"
                                    @click="quickSelect('after7day', 7)"
                                    :disabled="isFutureDisabled"
                                    style="border-top: 1px solid #ced4da; border-bottom: 1px solid #ced4da"
                                >
                                    {{ "+7 D" }}
                                </button>
                                <button
                                    class="btn quickDateButton btn-sm"
                                    @click="quickSelect('after30day', 30)"
                                    :disabled="isFutureDisabled"
                                    style="border: 1px solid #ced4da"
                                >
                                    {{ "+30 D" }}
                                </button>
                            </div>
                        </div>

                        <button class="btn btn-secondary btn-sm fixedheight nowbutton" @click="quickSelect('today', 0)">
                            {{ "오늘" }}
                        </button>
                        <span class="header-close-btn" @click="beforeHide"><i class="fa fa-times"></i></span>
                    </div>
                </div>
            </template>

            <div class="row m-0 modal-body-container">
                <div v-if="isAlarm" class="col-2 pl-0" style="height: 100%">
                    <div class="border alarm-info-container">
                        <div v-if="!isEmpty(totalLog)">
                            <AlarmInfoTable
                                :alarmDetail="alarmDetail"
                                :eventInfo="eventInfo"
                                :events="events"
                                :routeMgmt="routeMgmt"
                                :pointInfo="pointInfo"
                                :totalLog="totalLog"
                                @handle-total-log-modal="handleTotalLogModal"
                            />
                        </div>
                        <div
                            v-else
                            style="
                                height: 100%;
                                width: 100%;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                            "
                        >
                            <b-spinner variant="primary" label="Spinning"></b-spinner>
                        </div>
                    </div>
                </div>
                <div class="tab-container" :class="isAlarm ? 'col-10 p-0' : ''">
                    <ul class="custom-tabs">
                        <li
                            v-for="(tab, index) in tabs"
                            class="custom-tab"
                            :key="index"
                            :class="{ active: activeTab === index }"
                            @click="handleTabClick(index)"
                        >
                            {{ tab.label }}
                        </li>
                    </ul>
                    <div class="tab-content-container border p-3" :class="{ 'scrollable-y': activeTab === 3 }">
                        <div v-if="isEmpty(totalLog) && isLoading" class="body-container">
                            <b-spinner
                                v-if="activeTab !== 3 && isEmpty(totalLog) && isLoading"
                                variant="primary"
                                label="Spinning"
                            />
                        </div>
                        <component
                            v-if="!isLoading && tabs[activeTab]"
                            :is="tabs[activeTab].component"
                            v-bind="tabs[activeTab].props()"
                            :key="activeTab"
                        />
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import moment from "moment";
import backEndApi from "@src/api/backEndApi";
import DatePicker from "vue2-datepicker";
import TotalLogPanel from "../panel/TotalLogPanel.vue";
import CorrectionPanel from "../panel/CorrectionPanel.vue";
import AlarmInfoTable from "../table/AlarmInfoTable.vue";
import AccumulationPanel from "../panel/AccumulationPanel.vue";
import DataTrendPanel from "../panel/DataTrendPanel.vue";

export default {
    props: {
        pointInfo: { type: Object, default: () => {} },
        alarmDate: { type: String, default: "" },
        type: { type: String, default: "Point" },
        alarmDetail: { type: Object, default: () => {} },
        eventInfo: { type: Object, default: () => {} },
        routeMgmt: { type: Boolean, default: false },
    },
    components: {
        DatePicker,
        TotalLogPanel,
        CorrectionPanel,
        AlarmInfoTable,
        AccumulationPanel,
        DataTrendPanel,
    },
    data() {
        return {
            totalLog: [],
            day: moment().format("YYYYMMDD"),
            sDt: null,
            eDt: null,
            isLoading: false,
            events: null,
            activeTab: 0,
            tabs: [
                {
                    label: "데이터 수집 및 보정",
                    component: TotalLogPanel,
                    props: () => ({
                        totalLog: this.totalLog,
                        pointInfo: this.pointInfo,
                        events: this.events,
                        unit: this.unit,
                    }),
                },
                {
                    label: "결측 및 이상치 관리",
                    component: CorrectionPanel,
                    props: () => ({
                        totalLog: this.totalLog,
                        pointInfo: this.pointInfo,
                        events: this.events,
                        unit: this.unit,
                        eventDetail: this.eventDetail,
                    }),
                },
                {
                    label: "집계 현황 분석",
                    component: AccumulationPanel,
                    props: () => ({
                        hourData: this.hourData,
                        fiftyMinData: this.fiftyMinData,
                        fiveMinData: this.fiveMinData,
                        dailyData: this.dailyData,
                        monthData: this.monthData,
                        totalLog: this.totalLog,
                    }),
                },
                {
                    label: "데이터 트렌드 분석",
                    component: DataTrendPanel,
                    props: () => ({
                        title: "데이터 트렌드",
                        pointInfo: this.pointInfo,
                        selectedDate: this.day,
                        totalLog: this.totalLog,
                    }),
                },
            ],
            eventDetail: null,
            fiveMinData: [],
            fiftyMinData: [],
            hourData: [],
            dailyData: [],
            monthData: [],
        };
    },
    computed: {
        isFutureDisabled() {
            return this.day >= moment().format("YYYYMMDD");
        },
        unit() {
            let find;
            if (this.events && this.events.headers) {
                find = this.$store.state.units.find((unit) => unit.value == this.events.headers[0].unitSmallCode);
            }
            return find ? find.text : "-";
        },
        pointDetailInfo() {
            let unit, applyZoneIdx, itemUseageCode, energySourceCode;
            if (!this.isEmpty(this.pointInfo)) {
                unit = this.$store.state.units.find((item) => item.value == this.pointInfo.unitSmallCode);
                applyZoneIdx = this.$store.state.zoneInfo.find((item) => item.value == this.pointInfo.applyZoneIdx);
                itemUseageCode = this.$store.state.commonCodes.phscPointUsage.find(
                    (item) => item.value == this.pointInfo.itemUseageCode
                );
                energySourceCode = this.$store.state.commonCodes.energySourceCode.find(
                    (item) => item.value == this.pointInfo.energySourceCode
                );
            }
            return {
                unit: unit ? unit.text : "-",
                applyZoneIdx: applyZoneIdx ? applyZoneIdx.text : "-",
                itemUseageCode: itemUseageCode ? itemUseageCode.text : "-",
                energySourceCode: energySourceCode ? energySourceCode.text : "-",
            };
        },
        isAlarm() {
            return this.type == "Alarm" && !this.isEmpty(this.alarmDetail) ? true : false;
        },
    },
    watch: {},
    created() {},
    async mounted() {
        console.log("Mounted TotalLogModal");
        if (!this.isEmpty(this.alarmDate)) {
            this.day = moment(this.alarmDate).format("YYYYMMDD");

            this.sDt = moment(this.alarmDate).format("YYYYMMDD") + "000000";
            this.eDt = moment(this.alarmDate).format("YYYYMMDD") + "235959";
        } else {
            this.sDt = this.day + "000000";
            this.eDt = this.day + "235959";
        }

        await this.searchData(this.pointInfo, this.sDt, this.eDt);
    },
    beforeDestroy() {
        if (!this.isEmpty(this.totalLog)) this.totalLog = [];
    },
    destroyed() {},
    methods: {
        disableFutureDates(date) {
            return (
                date >
                moment()
                    .endOf("day")
                    .toDate()
            );
        },
        async onDayChange(val) {
            this.sDt = val + "000000";
            this.eDt = val + "235959";

            this.$refs.datePicker.closePopup();

            await this.searchData(this.pointInfo, this.sDt, this.eDt);
        },
        async moveDate(diff) {
            const newDay = moment(this.day, "YYYYMMDD").add(diff, "days");

            // 오늘 이후로 넘어가지 않게 제한
            const today = moment();
            if (newDay.isAfter(today, "day")) {
                this.day = today.format("YYYYMMDD");
            } else {
                this.day = newDay.format("YYYYMMDD");
            }

            this.sDt = this.day + "000000";
            this.eDt = this.day + "235959";
            await this.searchData(this.pointInfo, this.sDt, this.eDt);
        },
        async quickSelect(type, offset) {
            const base = type === "today" ? moment() : moment(this.day, "YYYYMMDD");
            const newDay = base.add(offset, "days");

            const today = moment();
            if (newDay.isAfter(today, "day")) {
                this.day = today.format("YYYYMMDD");
            } else {
                this.day = newDay.format("YYYYMMDD");
            }

            this.sDt = this.day + "000000";
            this.eDt = this.day + "235959";
            await this.searchData(this.pointInfo, this.sDt, this.eDt);
        },
        handleGlobalClick(e) {
            if (e.target.closest(".dataDownloadIcon")) {
                e.stopPropagation();
                // e.stopImmediatePropagation();
                e.preventDefault();
            }
        },
        handleTotalLogModal() {
            this.hideModal();
            this.openAlarmList();
            this.$emit("hide-alarm-popup");
        },
        openAlarmList() {
            this.$router.push("/system-mgmt/alarm-mgmt");
        },
        showModal() {
            this.$refs.totalLogModal.show();
        },
        hideModal() {
            this.$refs.totalLogModal.hide();
        },
        beforeHide() {
            this.$emit("hide");
        },
        async searchData(pointInfo, sDt, eDt) {
            this.searchTotalLog(pointInfo.ptAddr, sDt, eDt);
            this.getOuterlineData(pointInfo.ptAddr, sDt, eDt);
            this.searchSummaryByTimeUnit(pointInfo.ptIdx, 2, sDt, eDt); // 월 집계 데이터
            this.searchSummaryByTimeUnit(pointInfo.ptIdx, 3, sDt, eDt); // 일 집계 데이터
            this.searchSummaryByTimeUnit(pointInfo.ptIdx, 4, sDt, eDt); // 1시간 집계 데이터
            this.searchSummaryByTimeUnit(pointInfo.ptIdx, 5, sDt, eDt); // 15분 집계 데이터
            this.searchSummaryByTimeUnit(pointInfo.ptIdx, 6, sDt, eDt); // 5분 집계 데이터
        },
        async searchTotalLog(ptAddr, sDt, eDt) {
            this.isLoading = true;
            this.totalLog = [];
            try {
                let result = await backEndApi.totalLog.searchTotalLog(ptAddr, sDt, eDt);
                if (result.status == 200) {
                    this.totalLog = result.data;
                } else {
                    this.totalLog = [];
                    this.alertWarning(`${result.data.message}`);
                }
            } catch (e) {
                console.error(e);
            } finally {
                this.isLoading = false;
            }
        },
        async getOuterlineData(ptAddr, sDt, eDt) {
            try {
                let result = await backEndApi.outerline.getOuterlineData(ptAddr, sDt, eDt);
                if (result.status == 200) {
                    this.events = result.data;
                    console.log("this.eventInfo", this.eventInfo);
                    if (!this.isEmpty(this.events) && !this.isEmpty(this.eventInfo)) {
                        if (this.eventInfo.alarmType == "AbnormalData") {
                            this.eventDetail = this.events.abnormalEvents.find(
                                (item) => item.eventIdx == this.eventInfo.eventIdx
                            );
                        } else if (this.eventInfo.alarmType == "MissingData") {
                            this.eventDetail = this.events.missingStatus.find(
                                (item) => item.eventIdx == this.eventInfo.eventIdx
                            );
                        } else this.eventDetail = null;
                    }
                } else {
                    this.totalLog = [];
                    this.alertWarning(`${result.data.message}`);
                }
            } catch (e) {
                console.error(e);
            }
        },
        async searchSummaryByTimeUnit(ptIdx, type, sDt, eDt) {
            try {
                let adjSDt = sDt;
                let adjEDt = eDt;

                if (type === 3) {
                    const start = moment(sDt.toString(), "YYYYMMDDHHmmss").startOf("month");
                    const end = moment(sDt.toString(), "YYYYMMDDHHmmss").endOf("month");
                    adjSDt = start.format("YYYYMMDDHHmmss");
                    adjEDt = end.format("YYYYMMDDHHmmss");
                } else if (type === 2) {
                    const start = moment(sDt.toString(), "YYYYMMDDHHmmss").startOf("year");
                    const end = moment(sDt.toString(), "YYYYMMDDHHmmss").endOf("year");
                    adjSDt = start.format("YYYYMMDDHHmmss");
                    adjEDt = end.format("YYYYMMDDHHmmss");
                }

                let result = await backEndApi.summary.searchSummaryByTimeUnit(ptIdx, type, adjSDt, adjEDt);

                if (result.status == 200) {
                    if (type == 2) {
                        this.monthData = result.data.map((item) => ({
                            ...item,
                            regDt: moment(item.regDt.toString(), "YYYYMM").format("YYYY-MM"),
                        }));
                    } else if (type == 3) {
                        this.dailyData = result.data.map((item) => ({
                            ...item,
                            regDt: moment(item.regDt.toString(), "YYYYMMDD").format("YYYY-MM-DD"),
                        }));
                    } else if (type == 4) {
                        this.hourData = result.data.map((item) => ({
                            ...item,
                            regDt: moment(item.regDt.toString(), "YYYYMMDDHH").format("HH:mm:ss"),
                        }));
                    } else if (type == 5) {
                        this.fiftyMinData = result.data.map((item) => ({
                            ...item,
                            regDt: moment(item.regDt.toString(), "YYYYMMDDHHmmss").format("HH:mm:ss"),
                        }));
                    } else if (type == 6) {
                        this.fiveMinData = result.data.map((item) => ({
                            ...item,
                            regDt: moment(item.regDt.toString(), "YYYYMMDDHHmmss").format("HH:mm:ss"),
                        }));
                    } else return;
                } else {
                    this.alertWarning(`${result.data.message}`);
                }
            } catch (e) {
                console.error(e);
            }
        },
        handleTabClick(index) {
            this.activeTab = index;
        },
    },
};
</script>

<style scoped>
.fixedheight {
    height: 34px;
}
::v-deep .modal-header {
    padding: 12px !important;
}

::v-deep #total-log-modal .modal-dialog {
    width: 98% !important;
    max-width: 98% !important;
}

::v-deep .total-log-body {
    /* padding: 1rem 1rem 0.5rem 1rem !important; */
    height: 87vh !important;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.modal-body-container {
    /* padding: 20px; */
    height: 100%;
    /* display: flex; */
    /* flex-direction: column; */
    overflow: hidden;
}

/* .data-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
} */

.header-container {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.header-title {
    font-size: 14px;
    font-weight: 600;
    margin-right: 20px;
}

.header-close-btn {
    cursor: pointer;
    font-size: 14px;
    margin-left: 2rem;
}

.badge {
    display: inline-block;
    margin: 2px;
    padding: 0px 10px;
    min-width: 20px;
    white-space: nowrap;
    color: #fff;
    line-height: 22px;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 500;
    text-align: center;
    vertical-align: middle;
}

.badge.ptAddr {
    background-color: #ff6d00;
}

.badge.ptIdx {
    background-color: #546e7a;
}

.badge.option {
    background-color: #cfd8dc;
    color: #000;
}

.body-container {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.tab-container {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    /* overflow: hidden; */
}
.tab-content-container {
    flex: 1 1 auto;
    overflow: hidden;
    background-color: #fff;
    border-top-right-radius: 10px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    position: relative;
}
.scrollable-y {
    max-height: 80vh;
    overflow-y: auto;
    display: flex;
    justify-content: center;
}
.custom-tabs {
    display: flex;
    list-style: none;
    padding: 0;
    margin: 0;
}
.custom-tab {
    padding: 0.5rem 1.2rem;
    cursor: pointer;
    transition: all 0.2s ease;
    margin-right: 0.25rem;
    border-radius: 8px 8px 0 0;
    background-color: #f2f3f4;
    color: #495057;
    font-weight: 700;
    font-size: 13px;
    border-top: 1px solid #d5dbe0;
    border-right: 1px solid #d5dbe0;
    border-left: 1px solid #d5dbe0;
}
.custom-tab:hover {
    background-color: #e2e6ea;
}
.custom-tab.active {
    background-color: #348fe2;
    color: white;
}

.alarm-info-container {
    background-color: #fff;
    border-radius: 10px;
    height: 100%;
    padding: 10px;
    overflow-y: auto;
}
.quickDateButton {
    background-color: #e0e0e0;
}
.quickDateButton:hover {
    background-color: #bdbdbd;
}
.quickDateButton:disabled {
    background-color: #e0e0e0;
}
.notBorderRadius {
    border-radius: 0%;
}
.date-picker-container {
    /* box-shadow: rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 1px 1px; */
    display: flex;
    margin-right: 10px;
    border-radius: 6px;
}
.nowbutton {
    /* box-shadow: rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 1px 1px; */
}
</style>
